import type { User } from 'oidc-client';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../context/auth.context';
import { UserActionTypes, useUser } from '../context/user.context';
import LoginLoader from './login-loader.component';

const LoginCallback = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState();
  const { state, dispatch } = useUser();
  const { signinRedirectCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (signinRedirectCallback) {
      signinRedirectCallback()
        .then(async (res: User) => {
          const profile = res.profile;
          // Persist the opaque OIDC sub claim so Sentry (and other
          // non-PII consumers) can identify the user without email.
          if (profile.sub) {
            localStorage.setItem('userId', profile.sub);
          } else {
            localStorage.removeItem('userId');
          }
          dispatch({
            type: UserActionTypes.UpdateLoginStatus,
            payload: 'schema',
          });
          dispatch({
            type: UserActionTypes.UpdateUser,
            payload: {
              auth: true,
              user: {
                preferred_username: profile.preferred_username,
                schemas: profile['custom:schema'],
                superuser: profile['custom:superuser'],
              },
              tokens: {
                id_token: res.id_token,
                access_token: res.access_token,
                refresh_token: res.refresh_token,
                expires_at: res.expires_at,
                auth_time: profile.auth_time,
              },
            },
          });
        })
        .catch((error) => {
          localStorage.removeItem('UserState');
          dispatch({
            type: UserActionTypes.Reset,
          });
          setStatus(error.message);
        });
    }
  }, [signinRedirectCallback, dispatch]);

  useEffect(() => {
    if (state.auth) {
      // set navigation back to login page to handle schema selection.
      navigate('/login', { replace: true });
    }
  }, [state, navigate]);

  return (
    <div>
      <LoginLoader title={t('loading-user-data')} />
      {status && (
        <p>
          {t('error')}: {status}
        </p>
      )}
    </div>
  );
};
export default LoginCallback;
